import GenericDialog from "@cmp/genericDialog"
import { ManageProgramsStrip } from "./manageProgramsStrip"

// A focused "Manage programs" surface reachable in one click from the student
// row's actions menu, so staff don't have to open the whole profile drawer to
// add or remove a program. Same chips + add/remove as the drawer strip.
export function ManageProgramsDialog(props: {
  open: boolean
  studentId: string | null
  studentName?: string
  onClose: () => void
}) {
  const { open, studentId, studentName, onClose } = props
  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      size="xs"
      disableContentPadding
      title={`Manage programs${studentName ? ` · ${studentName}` : ""}`}
      content={
        studentId ? (
          <ManageProgramsStrip
            studentId={studentId}
            studentName={studentName}
            showHeader={false}
          />
        ) : null
      }
      buttons={[{ type: "secondary", text: "Done", onClick: onClose }]}
    />
  )
}
